import { getToken } from 'src/modules/authHandler';
import { getSeekId } from 'src/utils/account-selection';

import { getUploadUrl } from '../utils/getUploadUrl';

interface CallImageServiceParams {
  body?: any;
  headers?: any;
  id?: string;
  method?: 'GET' | 'PATCH' | 'POST';
}

type CallImageService = (args: CallImageServiceParams) => Promise<any>;

export const callImageService: CallImageService = async ({
  body,
  headers,
  id,
  method,
}) => {
  const token = await getToken();
  const uploadUrl = getUploadUrl();
  const urlId = id ? `/${id}` : '';
  const seekId = getSeekId();

  return fetch(`${uploadUrl}/client${urlId}`, {
    method: method || (id ? 'PATCH' : 'POST'),
    headers: {
      ...headers,
      'x-seek-advertiser-id': seekId,
      Authorization: `Bearer ${token}`,
    },
    body,
  });
};
